<template>
  <div class="grid_row">
    <v-slide-x-reverse-transition>
      <v-alert type="success" class="alert" v-if="alert_success === true">เพิ่มข้อมูลเรียบร้อย !</v-alert>
      <v-alert type="error" class="alert" v-if="alert_danger === true">ลบข้อมูลเรียบร้อย !</v-alert>
    </v-slide-x-reverse-transition>
    <v-form ref="save_pr" @submit.prevent="create_pr">
      <v-card>
        <div class="grid_half">
          <div class="grid_list pa-4">
            <div class="mt-3 mr-1">
              <v-text-field color="#86bc3a" label="เลขที่ใบเสร็จ" prepend-inner-icon="mdi-file-compare"
                :rules="[v => !!v || 'กรุณากรอกข้อมูล']" hide-details="auto" v-model="send_pr_receipt.recipe"
                outlined></v-text-field>
            </div>
            <div class="mt-3 mr-1">
              <div>
                <v-menu ref="menu_date" v-model="menu_date" :close-on-content-click="false" :return-value.sync="date"
                  transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field color="#86bc3a" v-model="date" label="วันที่(วัน/เดือน/ปี)"
                      :rules="[v => !!v || 'กรุณากรอกวันที่']" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs"
                      v-on="on" outlined></v-text-field>
                  </template>
                  <v-date-picker locale="TH" color="#86bc3a" @change="diffDateTH(dateEN)" :max="start_date"
                    v-model="dateEN" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="selectDate()">
                      ตกลง
                    </v-btn>
                    <v-btn text color="primary" @click="menu_date = false">
                      ยกเลิก
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </div>
            </div>
            <div class="mt-n1 mr-1">
              <v-autocomplete color="#86bc3a" :items="supplierType" item-text="name" item-value="id"
                @change="getProductList(send_pr_receipt.supplier_id)" v-model="send_pr_receipt.supplier_id"
                prepend-inner-icon="mdi-domain" label="ชื่อ บริษัท/Supplier Name" hide-details="auto"
                outlined></v-autocomplete>
            </div>
          </div>
          <div class="pa-4">
            <span>ภาษีการซื้อ</span>
            <v-radio-group v-model="send_pr_receipt.radio_vat" mandatory>
              <div class="d-flex justify-space-around">
                <div class="d-flex ml-5">
                  <div>
                    <v-radio color="#86bc3a" value="0"></v-radio>
                  </div>
                  <div>ภาษีรวมใน</div>
                </div>
                <div class="d-flex">
                  <div>
                    <v-radio color="#86bc3a" value="1"></v-radio>
                  </div>
                  <div>ภาษีแยกนอก</div>
                </div>
              </div>
              <div class="d-flex justify-space-around mt-6">
                <div class="d-flex" style="margin-left: 3px">
                  <div>
                    <v-radio color="#86bc3a" value="2"></v-radio>
                  </div>
                  <div>ไม่กระทบภาษี</div>
                </div>
                <div class="d-flex ml-n12">
                  <div>
                    <v-radio color="#86bc3a" value="3"></v-radio>
                  </div>
                  <div>ภาษีเป็น 0</div>
                </div>
              </div>
            </v-radio-group>
          </div>
        </div>
        <div class="grid_half">
          <div v-if="send_pr_receipt.radio_credit === 1">
            <div class="grid_list pa-4">
              <div class="mt-3 mr-1">
                <v-menu ref="menu_due_date" v-model="menu_due_date" :close-on-content-click="false"
                  :return-value.sync="dateDue" transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field color="#86bc3a" v-model="dateDue" label="วันที่ครบกำหนด(วัน/เดือน/ปี)"
                      :rules="[v => !!v || 'กรุณากรอกวันที่ครบกำหนด']" prepend-inner-icon="mdi-calendar" readonly
                      v-bind="attrs" v-on="on" outlined></v-text-field>
                  </template>
                  <v-date-picker locale="TH" color="#86bc3a" @change="diffDueDateTH(dateDueEN)" :min="start_date"
                    v-model="dateDueEN" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="selectDueDate()">
                      ตกลง
                    </v-btn>
                    <v-btn text color="primary" @click="menu_due_date = false">
                      ยกเลิก
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </div>
            </div>
          </div>
          <div v-else></div>
          <div class="pa-4">
            <span>ประเภท</span>
            <v-radio-group v-model="send_pr_receipt.radio_credit" mandatory>
              <div class="d-flex justify-space-around">
                <div class="d-flex ml-n4">
                  <div>
                    <v-radio color="#86bc3a" :value="0"></v-radio>
                  </div>
                  <div>เงินสด</div>
                </div>
                <div class="d-flex ml-n12">
                  <div>
                    <v-radio color="#86bc3a" :value="1"></v-radio>
                  </div>
                  <div>เครดิต</div>
                </div>
              </div>
            </v-radio-group>
          </div>
        </div>
        <div v-if="loading_product === true">
          <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
          </v-sheet>
        </div>
        <div v-else class="grid_full pl-4 pt-4 pr-4">

          <div style="display: flex; !important;" v-if="send_pr_receipt.supplier_id != null">
            <v-autocomplete color="#86bc3a" :items="product_list" item-text="name" item-value="id"
              @input="add_product(productType_input)" v-model="productType_input"
              prepend-inner-icon="mdi-flask-plus-outline" label="สินค้า" hide-details="auto" outlined />
          </div>
        </div>
        <div class="pa-2">
          <v-card-title>
            <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line
              hide-details></v-text-field>
          </v-card-title>
          <v-data-table :headers="Pr_List" :items="data_list" key="index" :search="search" mobile-breakpoint="0"
            hide-default-footer :items-per-page="100">
            <template slot="item" slot-scope="dataDetail">
              <tr>
                <td>{{ dataDetail.index + 1 }}</td>
                <td>{{ dataDetail.item.product_code }}</td>
                <td><v-text-field color="#86bc3a" label="ล็อต" :rules="[v => !!v || 'กรุณากรอกล็อต']" hide-details="auto"
                    v-model="dataDetail.item.product_lot" outlined></v-text-field></td>
                <td>{{ dataDetail.item.name }}</td>
                <td>
                  <v-select color="#86bc3a" label="หน่วยนับ" :rules="[v => !!v || 'กรุณากรอกหน่วยนับ']"
                    :items="dataDetail.item.units" item-text="name" item-value="unit_id" v-model="dataDetail.item.unit_id"
                    hide-details="auto" outlined />
                </td>
                <td>
                  <date-picker clearable class="input_style" :disabled-date="notBeforeToday" value-type="format"
                    :formatter="format" v-model="dataDetail.item.date_exp" :placeholder="dataDetail.item.date_exp" />
                </td>
                <td>
                  <v-text-field color="#86bc3a" type="number"
                    :rules="v => !!v && v > 0 && v > '0' || 'กรุณากรอกจำนวนและต้องมากกว่า 0'"
                    @keypress="isOnlyNumber($event)" label="จำนวน" hide-details="auto" min="0"
                    v-model="dataDetail.item.amount_total" outlined></v-text-field>
                </td>
                <td>
                  <v-text-field color="#86bc3a" type="number"
                    :rules="v => !!v && v > 0 && v > '0' || 'กรุณากรอกราคาและต้องมากกว่า 0'"
                    @keypress="isCurrency($event, dataDetail.item.unit_price)" label="ราคาต่อหน่วย" hide-details="auto"
                    min="0" v-model="dataDetail.item.unit_price" outlined></v-text-field>
                </td>
                <td>
                  <v-text-field color="#86bc3a" type="number"
                    @keypress="isCurrency($event, dataDetail.item.discount_unit)" label="ส่วนลด(บาท)" hide-details="auto"
                    min="0" v-model="dataDetail.item.discount_unit" aria-valuemax="6" outlined></v-text-field>
                </td>
                <td>
                  <v-text-field color="#86bc3a" type="number"
                    @keypress="isCurrency($event, dataDetail.item.discount_percent)" label="ส่วนลด(%)" hide-details="auto"
                    min="0" v-model="dataDetail.item.discount_percent" aria-valuemax="6" outlined></v-text-field>
                </td>
                <td>{{
                  format_price(dataDetail.item.total_price = (((dataDetail.item.unit_price) -
                    ((dataDetail.item.unit_price * dataDetail.item.discount_percent) / 100)) *
                    dataDetail.item.amount_total) - dataDetail.item.discount_unit)
                }}</td>
                <td>
                  <div class="v-input__slot">
                    <v-checkbox color="#86bc3a" v-model="dataDetail.item.status" />
                  </div>
                </td>
                <td class="pa-3">
                  <v-btn small height="42" @click="getDelete(dataDetail.item.loop_id)"
                    class="grad-danger-bg white--text mb-1">
                    <v-icon>mdi-delete-empty-outline</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
            <template v-slot:body.append>
              <tr>
                <td colspan="9" class="pa-2 border_col">
                  <div class="ma-4">
                    <div class="text-center">รวม</div>
                  </div>
                </td>
                <td colspan="4" class="pa-2 border_col text-center">
                  <div class="ma-4">
                    <div>{{ send_pr_receipt.grand_total = total_count }}</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="9" class="border_col"></td>
                <td colspan="2" class="pa-2 border_col">
                  <div class=" ma-4">
                    <div>ส่วนลดท้ายบิล (%)</div>
                  </div>
                </td>
                <td colspan="2" class="pa-2 border_col">
                  <div class="ma-4">
                    <div>
                      <v-text-field color="#86bc3a" label="ส่วนลดท้ายบิล (%)" type="number"
                        @keypress="isCurrency($event, send_pr_receipt.discount_percent)" hide-details="auto" min="0"
                        max="100" v-model="send_pr_receipt.discount_percent" outlined></v-text-field>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="9" class="border_col"></td>
                <td colspan="2" class="pa-2 border_col">
                  <div class=" ma-4">
                    <div>ส่วนลดท้ายบิล (หน่วย)</div>
                  </div>
                </td>
                <td colspan="2" class="pa-2 border_col">
                  <div class="ma-4">
                    <div>
                      <v-text-field color="#86bc3a" label="ส่วนลดท้ายบิล (หน่วย)" type="number"
                        @keypress="isCurrency($event, send_pr_receipt.discount_final)" hide-details="auto" min="0"
                        max="100" v-model="send_pr_receipt.discount_final" outlined></v-text-field>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="9" class="border_col"></td>
                <td colspan="2" class="border_col">
                  <div class="ml-2 mb-7">ราคาสินค้าไม่รวมภาษี</div>
                  <div class="ml-2 pt-1">ภาษีมูลค่าเพิ่ม 7%</div>
                </td>
                <td colspan="2" class="pa-2 border_col">
                  <div class="ma-4 text-center">{{ send_pr_receipt.product_no_vat = no_vat }}</div>
                  <v-divider />
                  <div class="ma-4 text-center">{{ send_pr_receipt.product_add_vat = cal_vat }}</div>
                </td>
              </tr>
              <tr>
                <td colspan="9" class="border_col"></td>
                <td colspan="2" class="pa-2 border_col">
                  <div class="ma-4">
                    <div>จำนวนเงินทั้งสิ้นรวมภาษี</div>
                  </div>
                </td>
                <td colspan="2" class="pa-2 border_col">
                  <div class="ma-4">
                    <!-- <div class="text-center">{{ send_pr_receipt.total_cost = (format_price(total_all - send_pr_receipt.discount_final)) }}</div> -->
                    <div class="text-center">{{ send_pr_receipt.total_cost = total_all }}</div>
                  </div>
                </td>
              </tr>
              <v-divider />
            </template>
          </v-data-table>
          <div class="pa-4">
            <div class="mb-4">
              หมายเหตุ
            </div>
            <v-textarea color="#86bc3a" label="กรุณากรอกหมายเหตุ" v-model="send_pr_receipt.note" outlined></v-textarea>
          </div>
        </div>
        <div class="pa-6 text-right">
          <v-btn x-large type="submit" class="grad-success-bg white--text" style="font-size: 18px">บันทึกข้อมูล</v-btn>
        </div>
      </v-card>
    </v-form>
    <v-overlay :value="overlay" class="z_index">
      <div class="text-center">
        <v-progress-circular indeterminate size="70" width="7" color="#86bc3a"></v-progress-circular>
        <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import { HTTP } from "@/axios";
import Swal from "sweetalert2";
import { formatPrice, minDate, onlyForCurrency, onlyForNumber } from "@/js/handler";
import DatePicker from "vue2-datepicker";
import moment from "moment";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  components: {
    DatePicker
  },
  name: "StoragePR",
  data() {
    return {
      date: '',
      dateEN: '',
      dateDue: '',
      dateDueEN: '',
      overlay: false,
      menu_date: false,
      menu_due_date: false,
      loading_product: false,
      pr_id: 0,
      start_date: this.min_date(),
      search: null,
      alert_success: false,
      alert_danger: false,
      format: {
        stringify: (date) => {
          const date_moment = moment(date).format('DD-MM-YYYY')
          const diff = date_moment.split('-')
          const day = diff[0]
          const month = diff[1]
          // const year = parseInt(diff[2]) + 543
          const year = parseInt(diff[2])
          return day + '-' + month + '-' + year
        },
      },
      productType_input: null,
      supplierType: [],
      product_list: [],
      data_list: [],
      unit_list: [],
      selected_arr: [],
      Pr_List: [
        {
          text: 'ลำดับ',
          value: 'loop_id',
          fixed: true,
          width: '95px',
        },
        {
          text: 'รหัสสินค้า',
          value: 'product_code',
          fixed: true,
          width: '125px',
        },
        {
          text: 'ล็อต',
          value: 'product_lot',
          fixed: true,
          width: '170px',
        },
        {
          text: 'รายการสินค้า',
          value: 'name',
          fixed: true,
          width: '200px',
        },
        {
          text: 'หน่วยนับ',
          value: 'units',
          sortable: false,
          fixed: true,
          width: '180px',
        },
        {
          text: 'วันที่หมดอายุ',
          value: 'date_exp',
          fixed: true,
          width: '95px',
        },
        {
          text: 'จำนวน',
          value: 'amount',
          fixed: true,
          width: '180px',
        },
        {
          text: 'ราคาต่อหน่วย',
          value: 'unit_price',
          fixed: true,
          width: '180px',
        },
        {
          text: 'ส่วนลด(บาท)',
          value: 'discount_unit',
          fixed: true,
          width: '180px',
        },
        {
          text: 'ส่วนลด(%)',
          value: 'discount_percent',
          fixed: true,
          width: '180px',
        },
        {
          text: 'ราคารวม',
          value: 'total_price',
          fixed: true,
          width: '180px',
        },
        {
          text: 'สินค้ารอคืน',
          value: 'status',
          sortable: false,
          fixed: true,
          width: '125px',
        },
        {
          text: 'ลบ',
          value: '',
          sortable: false,
          fixed: true,
          width: '50px',
        },
      ],
      send_pr_receipt: {
        recipe: null,
        radio_vat: '1',
        radio_credit: null,
        supplier_id: null,
        note: '',
        grand_total: '0',
        discount_percent: '0',
        discount_final: '0',
        product_no_vat: '0',
        product_add_vat: '0',
        total_cost: '0',
      },
    }
  },
  methods: {
    cache_page() {
      window.addEventListener('beforeunload', function (event) {
        event.preventDefault();
        event.returnValue = '';
      })
    },
    async selectDate() {
      this.$refs.menu_date.save(this.date);
      this.menu_date = false;
    },
    async selectDueDate() {
      this.$refs.menu_due_date.save(this.dateDue);
      this.menu_due_date = false;
    },
    date_table(value) {
      if (value !== null) {
        const diff = value.split('-')
        const day = diff[2]
        const month = diff[1]
        const year = parseInt(diff[0])
        return day + '-' + month + '-' + year
      }
      else {
        let result = this.min_date()
        const diff = result.split('-')
        const day = diff[2]
        const month = diff[1]
        const year = parseInt(diff[0])
        return day + '-' + month + '-' + year
      }
    },

    date_tableNow(value) {
      if (value !== null) {
        const diff = value.split('-')
        const day = diff[2]
        const month = diff[1]
        const year = parseInt(diff[0])
        return day + '-' + month + '-' + year
      }
      else {
        let result = this.min_date()
        const diff = result.split('-')
        const day = diff[2]
        const month = diff[1]
        const year = parseInt(diff[0])
        return day + '-' + month + '-' + year
      }
    },
    min_date: function () {
      return minDate()
    },
    diffDateTH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0]) + 543
      const final_date = day + '-' + month + '-' + year
      return this.date = final_date
    },
    diffDateEN() {
      const diff = this.date.split('-')
      const year = parseInt(diff[2]) - 543
      const month = diff[1]
      const day = diff[0]
      return year + '-' + month + '-' + day
    },
    diffDueDateTH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0]) + 543
      const final_date = day + '-' + month + '-' + year
      return this.dateDue = final_date
    },
    diffDueDateEN() {
      const diff = this.dateDue.split('-')
      const year = parseInt(diff[2]) - 543
      const month = diff[1]
      const day = diff[0]
      return year + '-' + month + '-' + day
    },
    format_price: function (value) {
      return formatPrice(value)
    },
    isOnlyNumber: function (evt, number) {
      return onlyForNumber(evt, number)
    },
    isCurrency: function (evt, number) {
      return onlyForCurrency(evt, number)
    },
    notBeforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
    getSupplier() {
      HTTP.post('/suppliers/all')
        .then((res) => {
          if (res.data.success === true) {
            this.supplierType = res.data.object.map((obj) => {
              return {
                id: obj.id,
                name: obj.department !== '-' && obj.department !== null ? obj.name + ' (' + obj.department + ')' : obj.name,
              }
            });
          }
        })
    },
    getProductList(supplier_id) {
      this.loading_product = true
      HTTP.post('/suppliers/getproducts', {
        supplier_id: supplier_id,
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_product = false
          this.product_list = res.data.object;
          this.data_list = [];
        }
      })
    },
    async add_product(pro_id) {
      let value = this.product_list.filter((res) => {
        console.log(res);
        return res.id == pro_id
      });
      this.alert_success = true;
      setTimeout(() => this.alert_success = false, 5000);
      value.forEach((details) => {
        let loop_id = this.pr_id += 1;
        this.data_list.push({
          loop_id: loop_id,
          product_id: details.product_id,
          product_code: details.product_code,
          product_lot: null,
          name: details.name,
          cost: 0,
          units: details.units,
          unit_id: details.unit_id,
          date_exp: this.date_table(this.min_date()),
          amount: null,
          amount_total: null,
          unit_price: null,
          discount_unit: null,
          discount_percent: null,
          total_price: 0,
          status: false,
        })
      })
      await this.$nextTick(() => {
        this.productType_input = null;
      })
    },
    getDelete(loop_id) {
      Swal.fire({
        text: 'ต้องการลบข้อมูลหรือไม่ ?',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((res) => {
        if (res.isConfirmed === true) {
          this.alert_danger = true
          setTimeout(() => this.alert_danger = false, 3000)
          this.data_list = this.data_list.filter(detail => detail.loop_id !== loop_id)
        }
      })
    },
    async create_pr() {
      let check_date_expired = false
      this.data_list.forEach((datalist, index) => {
        if (this.data_list[index].date_exp == null || this.data_list[index].date_exp == '') {
          check_date_expired = true
          return
        }
      });
      if (this.$refs.save_pr.validate()) {
        if (this.data_list.length > 0) {
          this.data_list.forEach((datalist, index) => {
            let item = datalist.units.find((detail) => {
              return detail.unit_id == datalist.unit_id
            })
            this.data_list[index].amount = item.qty * datalist.amount_total;
            this.data_list[index].cost = (parseFloat(datalist.total_price) / (parseInt(item.qty) * parseInt(datalist.amount_total)))

          })
          let duplicateIndices = [];
          this.data_list.forEach((element, index) => {
            // Find the index of the first occurrence of the current element
            const firstIndex = this.data_list.findIndex((e, i) => i !== index && e.product_id === element.product_id);
            // If a duplicate is found
            if (firstIndex !== -1) {
              // Add both the current index and the first occurrence index to the duplicateIndices array
              duplicateIndices.push(element);
            }
          });
          // console.log(duplicateIndices);
          let qty_arr = []
          let total_arr = []
          let product_id = []
          let checkcost = {}
          this.data_list.forEach(async (items) => {
            let item = null
            let check_product_id = product_id.find(o => o === items.product_id)
            if (check_product_id == null) {
              total_arr.push({ id: items.product_id, total: 0 })
              qty_arr.push({ id: items.product_id, qty: 0 })
              product_id.push(items.product_id)
            }
            item = items.units.find((detail) => {
              return items.unit_id == detail.unit_id;
            });
            let qtyObj = qty_arr.find(o => o.id === items.product_id);
            if (qtyObj) {
              qtyObj.qty += parseInt(items.amount_total * item.qty)
            }
            let totalObj = total_arr.find(o => o.id === items.product_id);
            if (totalObj) {
              totalObj.total += parseFloat(items.total_price)
            }
            checkcost = this.data_list.filter((res) => res.product_id === items.product_id)
            checkcost.forEach((details) => {
              details.cost = totalObj.total / qtyObj.qty

            });
          })
          let data = {
            user_id: this.$store.state.userDetail.id,
            user_name: this.$store.state.userDetail.name,
            number_receipt: this.send_pr_receipt.recipe,
            note: this.send_pr_receipt.note,
            date: this.dateEN,
            credit_date: this.dateDueEN,
            supplier_id: this.send_pr_receipt.supplier_id,
            is_credit: this.send_pr_receipt.radio_credit,
            status_vat: this.send_pr_receipt.radio_vat,
            pr_lists: await this.data_list,
            discount_percent: parseFloat(this.send_pr_receipt.discount_percent.replace(/,/g, '')),
            discount_final: parseFloat(this.send_pr_receipt.discount_final.replace(/,/g, '')),
            total_all: parseFloat(this.send_pr_receipt.total_cost.replace(/,/g, '')),
          }

          if (check_date_expired === true) {
            Swal.fire({
              title: 'ไม่สามารถดำเนินการได้ !',
              text: 'เนื่องจาก ไม่ได้กรอกวันหมดอายุของสินค้า !',
              icon: 'error',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            });
          }
          if (check_date_expired === false) {
            Swal.fire({
              text: 'ต้องการบันทึกข้อมูลหรือไม่ ?',
              icon: 'warning',
              showDenyButton: true,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            }).then((res) => {
              if (res.isConfirmed === true) {
                this.overlay = true
                HTTP.post('/imports/importbypr', data).then((res) => {
                  if (res.data.success === true) {
                    this.overlay = false
                    Swal.fire('บันทึกข้อมูลเรียบร้อย', '', 'success')
                      .then(() => {
                        this.$router.push('/stock/storage/addproducttostock');
                      });
                  }
                })
              }
            })
          }
        }
        else {
          Swal.fire({
            text: 'กรุณาตรวจสอบข้อมูล !',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          })
        }
      }
      else {
        Swal.fire({
          title: 'ไม่สามารถดำเนินการได้ !',
          text: 'เนื่องจาก ไม่มีข้อมูลหรือกรอกข้อมูลไม่ครบ',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        })
      }
    },
  },
  computed: {
    total_count() {
      // let data_list = this.data_list;
      // const result = data_list.reduce((sum,number) => {
      //   let total_all = (( (number.unit_price) - ((number.unit_price * number.discount_percent) / 100)) * number.amount_total) - number.discount_unit;
      //   if (total_all < 0) {
      //     return sum + 0;
      //   }
      //   else {
      //     return sum + total_all;
      //   }
      // }, 0)
      // return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      let data_list = this.data_list;
      const result = data_list.reduce((sum, number) => {
        return sum + number.total_price
      }, 0)
      return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    no_vat() {
      // let data_list = this.data_list;
      // const result = data_list.reduce((sum,number) => {
      //   if (this.send_pr_receipt.radio_vat == '0'){
      //     let total_price = (( (number.unit_price) - ((number.unit_price * number.discount_percent) / 100)) * number.amount_total) - number.discount_unit;
      //     let in_vat = ((total_price * 7)/107);
      //     return sum+(total_price - in_vat);
      //   }
      //   else if(this.send_pr_receipt.radio_vat == '1') {
      //     let total_price = (( (number.unit_price) - ((number.unit_price * number.discount_percent) / 100)) * number.amount_total) - number.discount_unit;
      //     // let calculate = (total_price * (7 / 100));
      //     return sum+(total_price);
      //   }
      //   else if (this.send_pr_receipt.radio_vat == '2'){
      //     let total_price = (( (number.unit_price) - ((number.unit_price * number.discount_percent) / 100)) * number.amount_total) - number.discount_unit;
      //     return sum+(total_price);
      //   }
      //   else if (this.send_pr_receipt.radio_vat == '3'){
      //     let total_price = (( (number.unit_price) - ((number.unit_price * number.discount_percent) / 100)) * number.amount_total) - number.discount_unit;
      //     return sum+(total_price);
      //   }
      // }, 0)
      // return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      let discount_percent = this.send_pr_receipt.discount_percent;
      let discount_unit = this.send_pr_receipt.discount_final;
      let data_list = this.data_list;
      const subTotal = data_list.reduce((sum, number) => {
        return sum + number.total_price
      }, 0);

      let percent = (parseFloat(subTotal) * discount_percent) / 100;
      let total_percent = parseFloat(subTotal) - percent;
      let total_discount = total_percent - discount_unit;

      if (this.send_pr_receipt.radio_vat == 0) {
        let before_vat = total_discount * (100 / 107);
        return before_vat.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return total_discount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    cal_vat() {
      // let data_list = this.data_list;
      // const result = data_list.reduce((sum,number) => {
      //   if (this.send_pr_receipt.radio_vat == '0') {
      //     let total_all = (( (number.unit_price) - ((number.unit_price * number.discount_percent) / 100)) * number.amount_total) - number.discount_unit;
      //     let calculate = ((total_all * 7)/107);
      //     return sum+(calculate);
      //   }
      //   else if (this.send_pr_receipt.radio_vat == '1'){
      //     let total_all = (( (number.unit_price) - ((number.unit_price * number.discount_percent) / 100)) * number.amount_total) - number.discount_unit;
      //     let calculate = (total_all * (7 / 100));
      //     // let cal_total = number.amount_total
      //     return sum+(calculate);
      //   }
      //   else if (this.send_pr_receipt.radio_vat == '2'){
      //     return sum+(0);
      //   }
      //   else if (this.send_pr_receipt.radio_vat == '3'){
      //     return sum+(0);
      //   }
      // }, 0)
      // return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      let discount_percent = this.send_pr_receipt.discount_percent;
      let discount_unit = this.send_pr_receipt.discount_final;
      let data_list = this.data_list;
      const subTotal = data_list.reduce((sum, number) => {
        return sum + number.total_price
      }, 0);

      let percent = (parseFloat(subTotal) * discount_percent) / 100;
      let total_percent = parseFloat(subTotal) - percent;
      let total_discount = total_percent - discount_unit;

      if (this.send_pr_receipt.radio_vat == 0) {
        let result_vat = total_discount * (7 / 107);
        return result_vat.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else if (this.send_pr_receipt.radio_vat == 1) {
        let result_vat = total_discount * (7 / 100);
        return result_vat.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        let zero = 0
        return zero.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    total_all() {
      // let data_list = this.data_list;
      // const result = data_list.reduce((sum,number) => {
      //   if (this.send_pr_receipt.radio_vat == '0'){
      //     let total_price = (( (number.unit_price) - ((number.unit_price * number.discount_percent) / 100)) * number.amount_total) - number.discount_unit;
      //     return sum+((total_price));
      //   }
      //   else if(this.send_pr_receipt.radio_vat == '1') {
      //     let total_price = (( (number.unit_price) - ((number.unit_price * number.discount_percent) / 100)) * number.amount_total) - number.discount_unit;
      //     let ex_vat = ((total_price * 7)/100);
      //     return sum+((total_price + ex_vat));
      //   }
      //   else if(this.send_pr_receipt.radio_vat == '2') {
      //     let total_price = (( (number.unit_price) - ((number.unit_price * number.discount_percent) / 100)) * number.amount_total) - number.discount_unit;
      //     return sum+(total_price);
      //   }
      //   else if(this.send_pr_receipt.radio_vat == '3') {
      //     let total_price = (( (number.unit_price) - ((number.unit_price * number.discount_percent) / 100)) * number.amount_total) - number.discount_unit;
      //     return sum+(total_price);
      //   }
      // }, 0)
      // return result;

      let result_vat = 0;
      let total_discount = 0;

      let discount_percent = this.send_pr_receipt.discount_percent;

      let discount_unit = this.send_pr_receipt.discount_final;
      let data_list = this.data_list;
      const subTotal = data_list.reduce((sum, number) => {
        return sum + number.total_price
      }, 0);

      let percent = (parseFloat(subTotal) * discount_percent) / 100;
      let total_percent = parseFloat(subTotal) - percent;
      if (this.send_pr_receipt.radio_vat == 1) {

        result_vat = total_percent - discount_unit;
        total_discount = result_vat * (7 / 100) + (result_vat);
      } else {
        total_discount = total_percent - discount_unit;
      }

      return total_discount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    },
  },
  mounted() {
    this.getSupplier();
  },
  created() {
    this.cache_page()
  },
}
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}

.border_col {
  border-left: #f1f1f1 solid 2px;
  border-right: #f1f1f1 solid 2px;
}

.grid_row {
  display: grid;
  grid-template-columns: 100%;
}

.grid_list {
  display: grid;
  grid-template-columns: 50% 50%;
}

.grid_full {
  display: grid;
  grid-template-columns: 100%;
}

.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.v-input__slot {
  align-items: center !important;
  justify-content: center !important;
  padding-top: 10px !important;
}

.input_style>>>input {
  border: #9e9e9e solid 1px !important;
  transition: 0.2s !important;
  font-size: 18px !important;
  color: black !important;
  padding: 27px !important;
  padding-left: 12px !important;
}

.input_style>>>input:hover {
  border-color: black !important;
}

.input_style>>>input:focus {
  border-color: #8cc63e !important;
}

@media only screen and (max-width: 1100px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
}

@media only screen and (max-width: 700px) {
  .grid_list {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
}
</style>
